import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "proposalvehicle_1cjwB",
  "use": "proposalvehicle_1cjwB-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" stroke=\"currentColor\" fill=\"none\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"proposalvehicle_1cjwB\">\n    <path d=\"M3 15 H6 L9 11 H15 L18 15 H21 V17 H3 Z\" />\n    \n    <path d=\"M12 11 V15\" />\n    \n    <circle cx=\"7\" cy=\"17\" r=\"2\" />\n    <circle cx=\"17\" cy=\"17\" r=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol